import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
// Import RxJs required methods

@Injectable()
export class LoginService {
  private loginURL = "LiftplanII/LoginOut/emailLogin.php";

  constructor(private http: HttpClient) {}
  /**
   * prueft ob schon eine Session vorhanden ist.
   */
  checkForLogin(): Promise<any> {
    const theURL: string = this.loginURL + "?action=checkForSession";
    return this.http.get(theURL).toPromise().catch(this.handleError);
  }
  doLogin(email: string, confirmation: string): Promise<boolean> {
    const theURL: string =
      this.loginURL +
      "?action=login&email=" +
      email +
      "&confirmation=" +
      confirmation;
    return this.http.get<boolean>(theURL).toPromise();
  }
  doLogout(): Promise<any> {
    const theURL: string = this.loginURL + "?action=logout";
    return this.http.get(theURL).toPromise();
  }

  private handleError(error: Response | any) {
    let errMsg: string;
    if (error instanceof Response) {
      const body = error.json() || "";
      const err = JSON.stringify(body);
      errMsg = `${error.status} - ${error.statusText || ""} ${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }
    console.error(errMsg);
    return Observable.throw(errMsg);
  }
}
